import React from 'react';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  const goodFit = ['You recently graduated or are about to graduate', 'You are applying but not getting traction', 'You are unsure what kind of work fits you', 'You feel behind or overwhelmed', 'You need help talking about your strengths', 'You want support, structure, and accountability', 'You are a parent looking for someone to help your grad get started'];
  const notFit = ['You only want someone to rewrite your resume', 'You are not ready to participate actively', 'You want a guaranteed job placement', 'You are looking for a large group program'];
  return <section className="py-20 md:py-24 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-233">
      <div className="text-center mb-16" data-id="element-234">
        <h2 className="text-4xl md:text-5xl font-serif" data-id="element-235">Who this is for</h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-236">
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-sage/30" data-id="element-237">
          <div className="flex items-center gap-3 mb-8" data-id="element-238">
            <div className="w-10 h-10 rounded-full bg-sage/20 flex items-center justify-center text-teal" data-id="element-239">
              <Check className="w-6 h-6" data-id="element-240" />
            </div>
            <h3 className="text-2xl font-serif" data-id="element-241">A good fit if:</h3>
          </div>
          <ul className="space-y-4" data-id="element-242">
            {goodFit.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink/80" data-id="element-243">
                <div className="w-1.5 h-1.5 rounded-full bg-teal mt-2.5 shrink-0" data-id="element-244"></div>
                <span data-id="element-245">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-mist/50 p-8 md:p-10 rounded-2xl border border-ink/5" data-id="element-246">
          <div className="flex items-center gap-3 mb-8" data-id="element-247">
            <div className="w-10 h-10 rounded-full bg-ink/5 flex items-center justify-center text-ink/60" data-id="element-248">
              <X className="w-6 h-6" data-id="element-249" />
            </div>
            <h3 className="text-2xl font-serif text-ink/60" data-id="element-250">Not a fit if:</h3>
          </div>
          <ul className="space-y-4" data-id="element-251">
            {notFit.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink/60" data-id="element-252">
                <div className="w-1.5 h-1.5 rounded-full bg-ink/20 mt-2.5 shrink-0" data-id="element-253"></div>
                <span data-id="element-254">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}